import React from 'react';
import { Box, Typography } from '@mui/material';
import { useCompany } from '../hooks/useCompany';
import useCompanyLogo from '../hooks/useCompanyLogo';

// Standard letterhead for reports & printed documents. Pulls name/logo/address/
// contact/KRA-PIN from the client's CompanyDetails (BC Company Information).
// Renders on screen AND on print (it is the document header).
const CompanyHeader = ({ title, subtitle }) => {
  const c = useCompany();
  // Auth-aware logo fetch (the download endpoint needs the token → see the hook).
  const logoUrl = useCompanyLogo(c);

  const addressLine = c ? [c.address, c.city, c.county].filter(Boolean).join(', ') : '';
  const contactBits = c ? [c.phone, c.phone2, c.email, c.website].filter(Boolean).join('  ·  ') : '';

  return (
    <Box sx={{ textAlign: 'center', mb: 2, pb: 1.5, borderBottom: '2px solid', borderColor: 'divider' }}>
      {c && (logoUrl || c.name) && (
        <Box display="flex" alignItems="center" justifyContent="center" gap={2} mb={0.5}>
          {logoUrl && <Box component="img" src={logoUrl} alt="" sx={{ height: 54, maxWidth: 120, objectFit: 'contain' }} />}
          <Box textAlign={logoUrl ? 'left' : 'center'}>
            <Typography variant="h5" fontWeight={800} lineHeight={1.1} sx={{ color: c.brandColor || '#0a1931' }}>
              {c.name}
            </Typography>
            {c.motto && <Typography variant="caption" fontStyle="italic" color="text.secondary">{c.motto}</Typography>}
          </Box>
        </Box>
      )}
      {addressLine && <Typography variant="caption" display="block">{addressLine}{c.postalCode ? `  ·  P.O. ${c.postalCode}` : ''}</Typography>}
      {contactBits && <Typography variant="caption" display="block" color="text.secondary">{contactBits}</Typography>}
      {c?.kraPin && <Typography variant="caption" display="block" color="text.secondary">Revenue Authority No.: {c.kraPin}</Typography>}
      {title && (
        <Typography variant="h6" fontWeight={700} mt={1.2}>
          {title}{subtitle ? ` — ${subtitle}` : ''}
        </Typography>
      )}
    </Box>
  );
};

export default CompanyHeader;
